
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15.464"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Component 28 – 6","transform":"translate(0 .231)"}},[_c('rect',{attrs:{"data-name":"Rectangle 16406","width":"15","height":"15","fill":"none"}}),_c('g',{attrs:{"data-name":"Group 48351"}},[_c('g',{attrs:{"data-name":"Group 48352","fill":"none","stroke":"#727998","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2"}},[_c('path',{attrs:{"data-name":"Path 37746","d":"M5.604 1.114a.888.888 0 01.875-.745h2.043a.887.887 0 01.874.745l.167 1.015a.989.989 0 00.508.692c.059.031.115.066.173.1a.976.976 0 00.847.1l.959-.361a.885.885 0 011.08.389l1.021 1.779a.894.894 0 01-.205 1.134l-.79.655a.984.984 0 00-.344.785v.2a.985.985 0 00.344.784l.792.656a.9.9 0 01.205 1.133l-1.022 1.778a.885.885 0 01-1.078.389l-.959-.361a.979.979 0 00-.848.1l-.173.1a.988.988 0 00-.507.692l-.167 1.014a.887.887 0 01-.874.745H6.478a.887.887 0 01-.874-.745l-.168-1.014a.988.988 0 00-.507-.692 4.871 4.871 0 01-.173-.1.975.975 0 00-.848-.1l-.959.361a.885.885 0 01-1.078-.389L.847 10.172a.894.894 0 01.205-1.134l.792-.655a.987.987 0 00.344-.785v-.2a.985.985 0 00-.344-.784l-.791-.661a.9.9 0 01-.206-1.13l1.021-1.78a.885.885 0 011.08-.39l.958.361a.975.975 0 00.848-.1c.056-.035.115-.069.173-.1a.984.984 0 00.504-.69L5.6 1.109z"}}),_c('path',{attrs:{"data-name":"Path 37747","d":"M9.184 7.498a1.685 1.685 0 11-1.686-1.685h0a1.686 1.686 0 011.686 1.685z"}})])])])])
          )
        }
      }
    